var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4418 4.89222C12.1344 4.66422 11.6895 4.71622 11.448 5.00622L6.45069 11.0115L4.05723 8.21355C3.81073 7.92755 3.3659 7.88088 3.06132 8.11221C2.75603 8.34355 2.70857 8.76355 2.95294 9.04955L5.90598 12.5015C6.04128 12.6589 6.24386 12.7502 6.45848 12.7502H6.46344C6.67878 12.7489 6.88278 12.6549 7.01594 12.4942L12.5629 5.82755C12.8044 5.53822 12.7506 5.11888 12.4418 4.89222ZM15.9834 4.89222C15.6753 4.66422 15.2312 4.71622 14.9896 5.00622L9.99236 11.0115L9.56452 10.5122L8.66848 11.5902L9.44765 12.5015C9.58294 12.6589 9.78552 12.7502 10.0001 12.7502H10.0051C10.2204 12.7489 10.4244 12.6549 10.5576 12.4942L16.1046 5.82755C16.3461 5.53822 16.2923 5.11888 15.9834 4.89222ZM7.74107 8.37994L6.84361 9.45728L6.49511 9.04994C6.25002 8.76328 6.29748 8.34328 6.60277 8.11194C6.90807 7.88128 7.35361 7.92728 7.59869 8.21394L7.74107 8.37994Z",
    fill: "#8F4300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_141577",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 15,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4418 4.89222C12.1344 4.66422 11.6895 4.71622 11.448 5.00622L6.45069 11.0115L4.05723 8.21355C3.81073 7.92755 3.3659 7.88088 3.06132 8.11221C2.75603 8.34355 2.70857 8.76355 2.95294 9.04955L5.90598 12.5015C6.04128 12.6589 6.24386 12.7502 6.45848 12.7502H6.46344C6.67878 12.7489 6.88278 12.6549 7.01594 12.4942L12.5629 5.82755C12.8044 5.53822 12.7506 5.11888 12.4418 4.89222ZM15.9834 4.89222C15.6753 4.66422 15.2312 4.71622 14.9896 5.00622L9.99236 11.0115L9.56452 10.5122L8.66848 11.5902L9.44765 12.5015C9.58294 12.6589 9.78552 12.7502 10.0001 12.7502H10.0051C10.2204 12.7489 10.4244 12.6549 10.5576 12.4942L16.1046 5.82755C16.3461 5.53822 16.2923 5.11888 15.9834 4.89222ZM7.74107 8.37994L6.84361 9.45728L6.49511 9.04994C6.25002 8.76328 6.29748 8.34328 6.60277 8.11194C6.90807 7.88128 7.35361 7.92728 7.59869 8.21394L7.74107 8.37994Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_141577)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.75,
    width: 17,
    height: 16,
    fill: "#8F4300"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTick);
export default __webpack_public_path__ + "static/media/double_tick.5312da612db1c5000b725e06ae3e1d43.svg";
export { ForwardRef as ReactComponent };